import { Formik, Form } from "formik";
import { TextField, Box, Typography, Button, Alert } from "@mui/material";
import { stageValidationSchema } from "../../utils/validations";

export const StageForm = ({
  initialValues,
  onSubmit,
  isSubmitting,
  editMode = false,
  submitLabel,
  showActions = true,
  onCancel,
}) => {
  const defaultValues = {
    name: "",
    color: "#3B82F6",
    probability: 50,
  };

  return (
    <Formik
      initialValues={initialValues || defaultValues}
      validationSchema={stageValidationSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        setFieldValue,
        handleBlur,
        isSubmitting: formSubmitting,
        handleSubmit,
      }) => (
        <Form id="stage-form" onSubmit={handleSubmit}>
          <TextField
            fullWidth
            name="name"
            placeholder="Stage Name *"
            value={values.name}
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.name && Boolean(errors.name)}
            helperText={touched.name && errors.name}
            sx={{
              borderRadius: "12px",
              mb: 2,
              "& .MuiInputBase-root": {
                height: "44px",
                borderRadius: "12px",
              },
            }}
          />

          <Box mb={2}>
            {/* <Typography variant="body2" mb={1}>
              Stage Color
            </Typography> */}
            <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
              <input
                type="color"
                value={values.color}
                onChange={(e) => setFieldValue("color", e.target.value)}
                style={{
                  width: 64,
                  height: 40,
                  border: "1px solid #E5E7EB",
                  borderRadius: 4,
                  cursor: "pointer",
                }}
              />
              <TextField
                name="color"
                value={values.color}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.color && Boolean(errors.color)}
                helperText={touched.color && errors.color}
                placeholder="#3B82F6"
                sx={{
                  flex: 1,
                  borderRadius: "12px",
                  mb: 1,
                  "& .MuiInputBase-root": {
                    height: "44px",
                    borderRadius: "12px",
                  },
                }}
              />
            </Box>
            <Typography variant="caption" color="text.secondary">
              Choose a color to identify this stage
            </Typography>
          </Box>

          {!editMode && (
            <Alert severity="info" sx={{ mt: 2 }}>
              <strong>Preview:</strong> Stage will be added at the end of your
              pipeline
            </Alert>
          )}

          {showActions && (
            <Box sx={{ display: "flex", gap: 2, mt: 3 }}>
              {onCancel && (
                <Button
                  variant="outlined"
                  fullWidth
                  onClick={onCancel}
                  disabled={isSubmitting || formSubmitting}
                >
                  Cancel
                </Button>
              )}
              <Button
                variant="contained"
                fullWidth
                type="submit"
                disabled={isSubmitting || formSubmitting}
                sx={{
                  color: "primary",
                  borderRadius: 4,
                }}
              >
                {isSubmitting || formSubmitting
                  ? editMode
                    ? "Saving..."
                    : "Creating..."
                  : submitLabel || (editMode ? "Save Changes" : "Create Stage")}
              </Button>
            </Box>
          )}
        </Form>
      )}
    </Formik>
  );
};
